// extracted by mini-css-extract-plugin
export default {"ticketValidation":"uploadExpenseTicketModal_ticketValidation__asvuQ"};